import React from 'react';
import { useDevelopmentDemo } from '../../contexts/DevelopmentDemoContext';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { DevProgress } from './DevProgress';
import { ParticipantPicker } from './ParticipantPicker';
export function DevProgressSection() {
  const {
    state
  } = useDevelopmentDemo();
  const reviewer = state.ui.workspace === 'reviewer';
  return <div data-id="element-679" data-mp="18ld8bsydh5u1">
      <DemoSectionHeader title={reviewer ? 'Progress' : 'My Progress'} description="The initial task and the reassessment, compared criterion by criterion." data-id="element-680" data-mp="18m51yy8estho" />
      {reviewer && <ParticipantPicker data-id="element-681" data-mp="zkfda05ww8nl" />}
      <DevProgress participantId={reviewer ? state.ui.selectedParticipantId : state.ui.actingParticipantId} data-id="element-682" data-mp="zjnhopcbeaxb" />
    </div>;
}